<footer class="footer">
  <div class="footer-container">
    <div class="footer-brand">
      <h3><a href="https://dreamagility.com" target="_blank" rel="noopener noreferrer">Dream Agility</a></h3>
      <!-- <p></p> -->
      <!-- <div class="social-links">
        <a href="https://www.linkedin.com/company/dream-agility" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" stroke="currentColor" stroke-width="2"/>
            <rect x="2" y="9" width="4" height="12" stroke="currentColor" stroke-width="2"/>
            <circle cx="4" cy="4" r="2" stroke="currentColor" stroke-width="2"/>
          </svg>
        </a>
      </div> -->
      <div class="footer-badges">
        <div class="badges-container">
          <a href="https://partnersdirectory.withgoogle.com/partners/8658324292" target="_blank" rel="noopener noreferrer">
            <img src="/images/badges/Partner-RGB.svg" alt="Google Partner" class="badge-image">
          </a>
          <img src="/images/badges/Microsoft-Select-Partner-1.webp" alt="Microsoft Select Partner" class="badge-image">
        </div>
      </div>
    </div>
    <div class="footer-links">
      <div class="footer-column">
        <h4>Useful Links</h4>
        <ul>
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/login">Login</a></li>
          <li><a routerLink="/info/performance-protection-short">Performance Protection</a></li>
        </ul>
      </div>
      <div class="footer-column">
        <h4>Support</h4>
        <ul>
          <li><a routerLink="/info/faq">FAQ</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
        </ul>
      </div>
      <div class="footer-column">
        <h4>Company</h4>
        <ul>
          <li><a href="https://dreamagility.com/about-us/" target="_blank" rel="noopener noreferrer">About Us</a></li>
          <li><a routerLink="/terms-and-conditions">Terms & Conditions</a></li>
          <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer-copyright">
    <p>Copyright © {{currentYear}} Dream AI LTD. All rights reserved.</p>
  </div>
</footer>
